export enum UserType {
    Private = 'Private',
    Company = 'Company',
    Brf = 'Brf',
    Manager = 'Manager',
    Unknown = 'Unknown'
  }